import { render, staticRenderFns } from "./WarehousesStarter.vue?vue&type=template&id=6b76d734&"
import script from "./WarehousesStarter.vue?vue&type=script&lang=js&"
export * from "./WarehousesStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports